import "./SenoritaHome.scss";
import "../../App.scss";
import { useTranslation } from "react-i18next";
import TelescopeImage from "../../components/atom/image/TelescopeImage";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import SenoritaHomeHook from "./SenoritaHomeHook";
import { getImage } from "../../api/ApiPath";
import { useEffect } from "react";
import LanguageSelect from "../../components/atom/language_drop_down/language";
const SenoritaHome = () => {
  const subDomain = window.location.href.includes("localhost:")
    ? "demo"
    : window.location.href
        .replaceAll("https://", "")
        .replaceAll("http://", "")
        .split(".")[0];
  const { t } = useTranslation();
  const utag = window.location.search;
  const {
    currentCompanyInfo,
    companyProduct,
    homeData,
    isLoading,
    currentLanguagesList,
  } = SenoritaHomeHook();

  useEffect(() => {
    if (!homeData) return;
    document.title =
      (homeData.title ?? currentCompanyInfo.title ?? "Iyilestir ") +
      " " +
      (homeData.titleExtension ?? "| Iyilestir");
  }, [homeData]);
  function renderTitle() {
    return (
      <div
        style={{ color: homeData?.titleColor }}
        className={"iyilestir-heading-4 senorita-title"}
      >
        {homeData?.mainText ?? "İyilestir"}
      </div>
    );
  }
  function renderMenuCard() {
    return (
      (companyProduct?.some((value: any) => value.productType === 1) ||
        homeData?.menuRedirectUrl) && (
        <div
          role={"button"}
          onClick={() =>
            (window.location.href = homeData.menuRedirectUrl
              ? homeData.menuRedirectUrl + window.location.search
              : `https://${subDomain}.iyilestir.io/menu${window.location.search}`)
          }
          className={"senorita-click-menu"}
          style={{
            backgroundColor: homeData?.iconColor ?? "rgba(166,103,77,1)",
          }}
        >
          <div className={"click-area"}>
            <div className={"iyilestir-caption"}>{t("click_menu")}</div>
            <div className={"img-area"}>
              {homeData.iconDesign ? (
                <div className={"favorite-icon"}>
                  <FavoriteIcon
                    style={{
                      color: homeData?.iconColor,
                    }}
                    className={"ico"}
                  />
                </div>
              ) : null}
              {
                <img
                  className={"img"}
                  style={{ backgroundColor: homeData?.titleColor }}
                  src={getImage(homeData?.mainPhotoUrl || "")}
                  alt={"menu"}
                />
              }
            </div>
          </div>
          <div className={"title-area"}>
            <div className={"iyilestir-heading-4"}>
              {homeData?.altText3 ?? currentCompanyInfo?.title}
            </div>
            <div className={"iyilestir-heading-4 x2"}>{t("digital_menu")}</div>
          </div>
        </div>
      )
    );
  }
  function renderFeedbackArea() {
    return (
      <div
        style={{ backgroundColor: (homeData?.titleColor ?? "#ffffff") + "26" }}
        role={"button"}
        onClick={() => {
          window.location.href = homeData?.feedbackRedirectUrl
            ? homeData?.feedbackRedirectUrl + window.location.search
            : `https://${subDomain}.iyilestir.io/feedback${utag}`;
        }}
        className={"feed-back-area"}
      >
        {homeData.iconDesign ? (
          <div className={"rating-ico"}>
            <ThumbUpIcon
              style={{
                color: homeData?.iconColor,
              }}
              className={"ico"}
            />
          </div>
        ) : null}
        <img
          className={"img"}
          src={getImage(homeData?.altPhotoUrl || "")}
          alt={"feedback"}
        />
        {/* Alttext ?? */}
        {homeData?.altText ? (
          <div
            style={{ color: homeData?.iconColor }}
            className={"iyilestir-heading-5"}
          >
            {homeData.altText}
          </div>
        ) : (
          <>
            <div
              style={{ color: homeData?.iconColor }}
              className={"iyilestir-heading-5"}
            >
              {t("how_to_today")}
            </div>
            <div
              style={{ color: homeData?.iconColor }}
              className={"iyilestir-heading-5 x2"}
            >
              {t("rating_me")}
            </div>
          </>
        )}
      </div>
    );
  }

  function renderSocialArea() {
    return (
      <div
        role={"button"}
        onClick={() =>
          (window.location.href =
            homeData?.otherRedirectUrl || currentCompanyInfo.instagram || "")
        }
        className={"video-area"}
        style={{ backgroundColor: (homeData?.titleColor ?? "#ffffff") + "26" }}
      >
        <div
          className={"video-ico"}
          onClick={() =>
            (window.location.href = currentCompanyInfo.instagram || "")
          }
        >
          <TelescopeImage className={"ico"} image={"video"} />
        </div>
        <div className={"video-play"}>
          <PlayCircleOutlineIcon className={"ico"} />
        </div>
        <img
          className={"img"}
          src={getImage(homeData?.altPhotoUrl2 || "")}
          alt={"other"}
        />
        {homeData?.altText2 ? (
          <div
            style={{ color: homeData?.iconColor }}
            className={"iyilestir-heading-5"}
          >
            {homeData.altText2}
          </div>
        ) : (
          <>
            <div
              style={{ color: homeData?.iconColor }}
              className={"iyilestir-heading-5"}
            >
              {t("product_video")}
            </div>
            <div
              style={{ color: homeData?.iconColor }}
              className={"iyilestir-heading-5 x2"}
            >
              {t("you_will_view")}
            </div>
          </>
        )}
      </div>
    );
  }

  return isLoading ? (
    <div>Loading..</div>
  ) : homeData ? (
    <div
      className={"senorita-home-root"}
      style={{ backgroundColor: homeData?.backgroundColor }}
    >
      {
        <LanguageSelect
          homeData={homeData}
          currentLanguagesList={currentLanguagesList}
        />
      }
      <div className={"senorita-body"}>
        {renderTitle()}
        <div className={"margin-vertical-32"}></div>
        {renderMenuCard()}
        <div className={"senorita-feed-back-area"}>
          {renderFeedbackArea()}
          {renderSocialArea()}
        </div>

        <div className={"senorita-logo-area"}>
          <img
            className={"img"}
            src={getImage(
              homeData?.footerLogoUrl || currentCompanyInfo?.logoPhotoUrl || ""
            )}
            alt={"footer_logo"}
          />
        </div>
        <div className={"senorita-footer"}>
          <img
            className={"img"}
            src={getImage(homeData?.footerObj?.footerLogo || "")}
            alt={"footer_company"}
            style={{
              cursor: homeData?.footerObj?.redirectLink ? "pointer" : "default",
            }}
            onClick={() => {
              if (homeData?.footerObj?.redirectLink) {
                window.location.href = homeData.footerObj.redirectLink;
              }
            }}
          />
          <div
            style={{ color: homeData?.titleColor }}
            className={"margin-vertical-8 iyilestir-caption-medium"}
          >
            {homeData?.footerObj?.description}
          </div>
          <div
            style={{ color: homeData?.iconColor }}
            className={"iyilestir-caption-medium"}
          >
            {homeData?.footerObj?.copyrightText}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>{t("not_found")}</div>
  );
};
export default SenoritaHome;
